var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6909 14.0629L20.5001 14.6997V13.67V7.72001V7.05793L19.8633 7.23909L10.6533 9.85909L10.2901 9.96241V10.34V18.41C10.2901 20.113 8.89487 21.5 7.20011 21.5C5.49625 21.5 4.11011 20.1139 4.11011 18.41C4.11011 16.7171 5.49534 15.33 7.20011 15.33C7.90952 15.33 8.55397 15.577 9.08494 15.9861L9.89011 16.6065V15.59V6.75001C9.89011 5.50932 10.6253 4.56482 11.8202 4.24279L11.8219 4.24231L17.6019 2.66231L17.602 2.6623C18.6838 2.36641 19.4928 2.49559 20.0247 2.9059L20.0247 2.90595L20.031 2.91068C20.5664 3.31031 20.8901 4.02594 20.8901 5.18001V16.48C20.8901 18.1839 19.504 19.57 17.8001 19.57C16.1053 19.57 14.7101 18.183 14.7101 16.48C14.7101 14.788 16.1044 13.4 17.8001 13.4C18.5199 13.4 19.1625 13.6472 19.6909 14.0629Z",
    fill: "#6C84F8",
    stroke: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicSvg);
export default __webpack_public_path__ + "static/media/musicSvg.0098c1cde0901179b64c00ad95faf9d1.svg";
export { ForwardRef as ReactComponent };